import { useEffect, useState } from 'react';
import {
  getLastOfflineCacheUse,
  subscribeToOfflineCacheUse,
  type OfflineCacheUse,
} from '@/offline/offlineApiCache';

export function useOfflineDataStatus(): OfflineCacheUse | null {
  const [cacheUse, setCacheUse] = useState(() => getLastOfflineCacheUse());

  useEffect(() => subscribeToOfflineCacheUse(setCacheUse), []);

  return cacheUse;
}
